module.exports = "pegasus/assets/blocks/column-3-theme4.png";